import { ChangeDetectionStrategy, Component, output, signal, input } from '@angular/core';
import { UserRole, UserRoleTranslationMapper } from '@dss-libs/shared/type/common-types';

import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
@Component({
  selector: 'dss-libs-ui-role-dropdown',
  imports: [MatMenu, MatMenuTrigger, TranslocoDirective, TranslocoPipe],
  templateUrl: './user-role-dropdown.component.html',
  styleUrl: './user-role-dropdown.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserRoleDropdownComponent {
  readonly role = input.required<UserRole>();
  readonly userId = input.required<string>();
  readonly disabled = input(false);

  readonly roles = signal(Object.values(UserRole).filter((role) => role !== UserRole.Owner));
  readonly roleChange = output<{ id: string; role: UserRole }>();
  protected readonly UserRoleTranslationMapper = UserRoleTranslationMapper;
  protected readonly UserRole = UserRole;

  selectedValue(role: UserRole) {
    if (role === this.role()) return;
    this.roleChange.emit({ id: this.userId(), role });
  }
}
